import PropTypes from 'prop-types';

import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Icon from '@mui/material/Icon';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import typography from 'assets/theme/base/typography';

export default function AuthFooter({ light }) {
  const { size } = typography;

  const textColor = light ? 'white' : 'text';
  const strongColor = light ? 'white' : 'dark';

  return (
    <MDBox
      component="footer"
      width="100%"
      sx={{
        position: 'relative',
        mt: { xs: 2, sm: 3 },
        pb: { xs: 1.5, sm: 2 },
      }}
    >
      {/* premium surface */}
      <MDBox
        sx={{
          width: '100%',
          borderTop: `1px solid ${light ? 'rgba(255,255,255,0.14)' : 'rgba(0,0,0,0.08)'}`,
          background: light
            ? 'linear-gradient(180deg, rgba(255,255,255,0.10), rgba(255,255,255,0.04))'
            : 'linear-gradient(180deg, rgba(255,255,255,0.75), rgba(255,255,255,0.55))',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
        }}
      >
        <Container
          maxWidth="xl"
          disableGutters
          sx={{
            px: { xs: 2, sm: 3, lg: 6 }, // büyük ekranda yatayda kaplar ama “premium margin” bırakır
            py: { xs: 1.5, sm: 2 },
          }}
        >
          <MDBox
            width="100%"
            display="flex"
            flexDirection={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            alignItems={{ xs: 'center', md: 'center' }}
            gap={{ xs: 1, md: 1.5 }}
            textAlign={{ xs: 'center', md: 'left' }}
          >
            {/* Left */}
            <MDBox
              display="flex"
              alignItems="center"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              flexWrap="wrap"
              color={textColor}
              fontSize={size.sm}
              sx={{
                opacity: 0.92,
                letterSpacing: '0.01em',
              }}
            >
              © {new Date().getFullYear()}{' '}
              <MDTypography
                component="span"
                variant="button"
                fontWeight="medium"
                color={strongColor}
                sx={{ mx: 0.6 }}
              >
                SolisUp
              </MDTypography>
              <MDTypography
                component="span"
                variant="button"
                fontWeight="regular"
                color={textColor}
                sx={{ opacity: 0.9 }}
              >
                • Pilates stüdyosu yönetim paneli
              </MDTypography>
              <MDBox
                fontSize={size.md}
                color={strongColor}
                mb={-0.5}
                mx={0.8}
                sx={{ opacity: 0.95 }}
              >
                <Icon color="inherit" fontSize="inherit">
                  favorite
                </Icon>
              </MDBox>
            </MDBox>

            {/* Right */}
            <MDBox
              component="ul"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                listStyle: 'none',
                m: 0,
                p: 0,
                gap: { xs: 1, sm: 1.25 },
              }}
            >
              {[
                { href: '/terms', label: 'Kullanım Koşulları' },
                { href: '/privacy', label: 'Gizlilik' },
                { href: 'mailto:destek@solisup.com', label: 'Destek' },
                { href: '/status', label: 'Sistem Durumu' },
              ].map((item) => (
                <MDBox key={item.href} component="li" lineHeight={1}>
                  <Link
                    href={item.href}
                    underline="none"
                    sx={{
                      display: 'inline-flex',
                      borderRadius: '10px',
                      px: 1,
                      py: 0.6,
                      transition: 'all 160ms ease',
                      '&:hover': {
                        backgroundColor: light ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.04)',
                        transform: 'translateY(-1px)',
                      },
                      '&:active': { transform: 'translateY(0px)' },
                    }}
                  >
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color={textColor}
                      sx={{ opacity: 0.9 }}
                    >
                      {item.label}
                    </MDTypography>
                  </Link>
                </MDBox>
              ))}
            </MDBox>
          </MDBox>
        </Container>
      </MDBox>
    </MDBox>
  );
}

AuthFooter.defaultProps = { light: false };
AuthFooter.propTypes = { light: PropTypes.bool };
